export const DebtSendingScheduleTrigger = {
  Periodically: "Periodically",
  DebtLimitReached: "Debt Limit Reached",
};
export const DebtSendingScheduleTriggerOptions = [
  DebtSendingScheduleTrigger.Periodically,
  DebtSendingScheduleTrigger.DebtLimitReached,
];
